import styled from "styled-components";
import { useState } from "react";
import React from "react";

type PaymentMethod = "card" | "paynow" | "bank";

const PaymentApp: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>("card");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isPaid, setIsPaid] = useState(false);

  const handlePayment = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      setIsPaid(true);
    }, 2000);
  };

  // ✅ SUCCESS SCREEN
  if (isPaid) {
    return (
      <PaymentWrapper>
        <SuccessCard>
          <SuccessIcon>✓</SuccessIcon>

          <h2>Payment Successful</h2>
          <p>Your payment has been processed successfully.</p>

          <PrimaryBtn onClick={onClose}>Back to Dashboard</PrimaryBtn>
        </SuccessCard>
      </PaymentWrapper>
    );
  }

  return (
    <PaymentWrapper>
      {/* Header */}
      <PaymentHeader>
        <BackBtn onClick={onClose}>←</BackBtn>

        <div style={{ width: 30 }} />
      </PaymentHeader>

      {/* Body */}
      <Content>
        <Heading>Make Payment</Heading>

        {/* Invoice */}
        <CardBox>
          <RowBetween>
            <div>
              <Small>Invoice</Small>
              <Strong>INV-2026-001</Strong>
            </div>
            <Badge>PENDING</Badge>
          </RowBetween>

          <RowBetween>
            <span>Amount</span>
            <Strong>SGD 128.59</Strong>
          </RowBetween>
        </CardBox>

        {/* Payment Methods */}
        <Section>
          <SubHeading>Select Payment Method</SubHeading>

          <Method
            active={paymentMethod === "card"}
            onClick={() => setPaymentMethod("card")}
          >
            💳 Credit / Debit Card
          </Method>

          <Method
            active={paymentMethod === "paynow"}
            onClick={() => setPaymentMethod("paynow")}
          >
            🔳 PayNow
          </Method>

          <Method
            active={paymentMethod === "bank"}
            onClick={() => setPaymentMethod("bank")}
          >
            🏦 Bank Transfer
          </Method>
        </Section>

        {/* Card Inputs */}
        {paymentMethod === "card" && (
          <>
            <Input placeholder="Card Number" />
            <Row>
              <Input placeholder="MM/YY" />
              <Input placeholder="CVV" />
            </Row>
          </>
        )}

        {/* Summary */}
        <CardBox>
          <RowBetween>
            <span>Total</span>
            <Strong>SGD 128.59</Strong>
          </RowBetween>
        </CardBox>

        {/* Pay Button */}
        <PayBtn onClick={handlePayment} disabled={isProcessing}>
          {isProcessing ? "Processing..." : "Pay Now"}
        </PayBtn>

        <Footer>🔒 Secure payment</Footer>
      </Content>
    </PaymentWrapper>
  );
};

export default PaymentApp;

const PaymentWrapper = styled.div`
  padding: 16px;
`;

const PaymentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackBtn = styled.button`
  border: none;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
`;

const TitleRow = styled.div`
  display: flex;
  gap: 6px;
  font-weight: bold;
  align-items: center;
`;

const ShieldIcon = styled.span`
  font-size: 18px;
`;

const Content = styled.div`
  margin-top: 20px;
`;

const Heading = styled.h2`
  margin-bottom: 10px;
`;

const SubHeading = styled.h3`
  font-size: 14px;
  margin-bottom: 8px;
`;

const CardBox = styled.div`
  background: #f8fafc;
  padding: 12px;
  border-radius: 10px;
  margin-bottom: 12px;
`;

const Section = styled.div`
  margin-top: 10px;
`;

const Method = styled.div<{ active?: boolean }>`
  padding: 12px;
  border: 1px solid ${({ active }) => (active ? "#22c55e" : "#e5e7eb")};
  border-radius: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  background: ${({ active }) => (active ? "#ecfdf5" : "white")};
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const RowBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

const Badge = styled.span`
  background: #dcfce7;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 12px;
`;

const Strong = styled.span`
  font-weight: 600;
`;

const Small = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const PayBtn = styled.button`
  width: 100%;
  margin-top: 12px;
  padding: 14px;
  background: #22c55e;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
`;

const PrimaryBtn = styled.button`
  margin-top: 16px;
  padding: 12px 16px;
  background: #22c55e;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
`;

const SuccessCard = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const SuccessIcon = styled.div`
  font-size: 40px;
  color: #22c55e;
  margin-bottom: 10px;
`;

const Footer = styled.div`
  margin-top: 20px;
  font-size: 12px;
  text-align: center;
  color: #6b7280;
`;
